import { render } from "./KnockTable.vue?vue&type=template&id=407da23e&scoped=true"
import script from "./KnockTable.vue?vue&type=script&lang=js"
export * from "./KnockTable.vue?vue&type=script&lang=js"

import "./KnockTable.vue?vue&type=style&index=0&id=407da23e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407da23e"]])

export default __exports__